
import {
  defineComponent,
  h,
  onMounted,
  provide,
  ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { useViewportObserver } from '~/composables/useViewportObserver'

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Tabs',
  props: {
    openTab: {
      type: Number,
      default: 1
    },
    tabMaxContentHeight: {
      type: String,
      default: ''
    },
    tabShowText: {
      type: String,
      default: 'show'
    },
    tabHideText: {
      type: String,
      default: 'hide'
    }
  },
  setup (props, { emit, slots }) {
    const { openTab, tabMaxContentHeight, tabShowText, tabHideText } = toRefs(props)
    const { isMobile } = useViewportObserver()
    const initialTabActivated = ref<boolean>(false)
    const lastActiveIndex = ref<number>(0)
    const activeIndex = ref<number>(0)

    provide('tabConfig', {
      tabMaxContentHeight,
      tabShowText,
      tabHideText,
      activeIndex,
      setActiveIndex
    })

    function setActiveIndex (index: number): void {
      lastActiveIndex.value = activeIndex.value
      if (isMobile.value && index === activeIndex.value) {
        activeIndex.value = null
      } else {
        activeIndex.value = index
        emit('click:tab', activeIndex.value + 1)
      }
    }

    watch(isMobile, (newValue) => {
      if (!newValue && activeIndex.value === null) {
        activeIndex.value = lastActiveIndex.value
      }
    })

    watch(openTab, () => {
      setActiveIndex(props.openTab - 1)
    }, { immediate: true })

    onMounted(() => {
      initialTabActivated.value = true
    })

    return () => {
      const child = slots.default()
      child.filter(vNode => vNode.componentOptions).forEach((vNode, i) => {
        vNode.data.attrs.index = i
      })
      child.push(h('div', { class: 'tabs__line' }))
      return h('div', { class: 'tabs' }, child)
    }
  }
})
